import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image-coming-soon-dark.jpg")